import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as PdfExportActions from './pdf-export.action';
import { selectPdfExportError, selectPdfExportLink, selectPdfExportStatus } from './pdf-export.selectors';
import { PdfExportDomain } from '@mode/shared/contract-common';
import { filter, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';

@Injectable({
  providedIn: 'root',
})
export class PdfExportFacade {
  constructor(
    private store: Store,
    private actions$: Actions
  ) {
    this.actions$
      .pipe(
        ofType(PdfExportActions.createPdfExportSubmitted, PdfExportActions.createPdfExportFailed),
        filter((action) => !!action.showDialog)
      )
      .subscribe(() => {
        this.openPdfExportModal$.next();
      });
  }

  public openPdfExportModal$: Subject<void> = new Subject();
  public currentExportJob: PdfExportDomain.PdfExportJob | undefined;

  openPdfExportModal() {
    this.openPdfExportModal$.next();
  }

  exportPdf(reportRunToken: string, showDialog: boolean): PdfExportDomain.PdfExportJob {
    this.store.dispatch(
      PdfExportActions.createPdfExport({
        reportRunToken: reportRunToken,
        showDialog,
      })
    );

    this.currentExportJob = {
      complete$: this.store
        .select(selectPdfExportStatus)
        .pipe(
          map(
            (status) =>
              status === PdfExportDomain.PdfExportState.Completed || status === PdfExportDomain.PdfExportState.Failed
          )
        ),
      error$: this.store.select(selectPdfExportError),
      link$: this.store.select(selectPdfExportLink),
    };

    return this.currentExportJob;
  }
}
